import { z } from "zod";

export const StatisticsOverallOutputSchema = z.object({
    value: z.number(),
    compareValue: z.number().nullable(),
    compareDateFrom: z.string().nullable(),
    compareDateTo: z.string().nullable(),
    compareRatio: z.number().nullable(),
});

export type StatisticsOverallOutput = z.infer<typeof StatisticsOverallOutputSchema>;